export class SimulatorList {
    public bayName: string;
    public bayNumber: number;
    public capacity: number;
    public isAvailable: boolean;
}
